import "./GetStarted.module.css";
import Header from "@/reusable_sections/Header";
import GetStartedHero from "./sections/GetStartedHero";
import ConsultationForm from "./sections/ConsultationForm";
import AdditionalCta from "./sections/AdditionalCta";
import Footer from "@/reusable_sections/Footer";
export default function GetStartedPage() {
  return <div>
      <Header />
      <GetStartedHero />
      <ConsultationForm />
      <AdditionalCta />
      <Footer />
    </div>;
}